import { webapiApi } from "../../webapiApi";

// =============================================================================
// Enums (matching OpenAPI spec)
// =============================================================================

/** Single source of truth for announcement type literals (enum-like `as const`). */
export const AnnouncementType = {
  Unknown: "Unknown",
  News: "News",
  Issue: "Issue",
  NewVersion: "NewVersion",
  Maintenance: "Maintenance",
} as const;
export type AnnouncementType =
  (typeof AnnouncementType)[keyof typeof AnnouncementType];

/** Single source of truth for announcement `appliesTo` target literals. */
export const AnnouncementTarget = {
  All: "All",
  Dashboard: "Dashboard",
  InboundOrders: "InboundOrders",
  Stock: "Stock",
  OutboundOrders: "OutboundOrders",
  Containers: "Containers",
  RoadTransport: "RoadTransport",
  AddressBook: "AddressBook",
  Billing: "Billing",
} as const;
export type AnnouncementTarget =
  (typeof AnnouncementTarget)[keyof typeof AnnouncementTarget];

// =============================================================================
// Response Types
// =============================================================================

export interface AnnouncementResponse {
  id: string;
  title: string;
  message: string;
  type: AnnouncementType;
  appliesTo: AnnouncementTarget[];
  startDate: string;
  endDate: string;
}

export interface AnnouncementsPagedResponse {
  items: AnnouncementResponse[];
  total: number;
  index: number;
  size: number;
}

// =============================================================================
// Query Parameters
// =============================================================================

export interface GetActiveAnnouncementsParams {
  Type?: AnnouncementType;
  AppliesTo?: AnnouncementTarget;
  OrderBy?: string;
  PageIndex?: number;
  PageSize?: number;
}

// =============================================================================
// API Endpoints
// =============================================================================

export const announcementsApi = webapiApi.injectEndpoints({
  endpoints: (builder) => ({
    getActiveAnnouncements: builder.query<
      AnnouncementsPagedResponse,
      GetActiveAnnouncementsParams | void
    >({
      query: (params) => ({
        url: "/announcements",
        params: params ?? undefined,
      }),
      providesTags: [{ type: "Announcement", id: "LIST" }],
    }),
  }),
});

export const { useGetActiveAnnouncementsQuery } = announcementsApi;
